/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../../public/upgrade/feature/pointOfSale/delivery-instructions/default-instructions/default-instructions.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../../../public/upgrade/root/modal/modal.service';
import * as import10 from '../../../../../../../public/upgrade/core/logger.service';
import * as import11 from '@ngx-translate/core/src/translate.service';
import * as import12 from '../../../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import13 from '@ngx-translate/core/src/translate.pipe';
import * as import14 from '@angular/core/src/linker/view_container';
import * as import15 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import16 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import17 from '@angular/core/src/linker/element_ref';
import * as import18 from '@angular/common/src/directives/ng_class';
import * as import19 from '@angular/core/src/linker/query_list';
import * as import20 from '../../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import21 from '@angular/core/src/linker/template_ref';
import * as import22 from '@angular/common/src/directives/ng_for';
export class Wrapper_DefaultInstructionsComponent {
  /*private*/ _eventHandler:Function;
  context:import0.DefaultInstructionsComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  constructor(p0:any,p1:any,p2:any) {
    this._changed = false;
    this.context = new import0.DefaultInstructionsComponent(p0,p1,p2);
    this._expr_0 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_dto(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.dto = currValue;
      this._expr_0 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_DefaultInstructionsComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_DefaultInstructionsComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.DefaultInstructionsComponent>;
  _DefaultInstructionsComponent_0_3:Wrapper_DefaultInstructionsComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_DefaultInstructionsComponent_Host0,renderType_DefaultInstructionsComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'default-instructions',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_DefaultInstructionsComponent0(this.viewUtils,this,0,this._el_0);
    this._DefaultInstructionsComponent_0_3 = new Wrapper_DefaultInstructionsComponent(this.injectorGet(import9.ModalService,this.parentIndex),this.injectorGet(import10.LoggerService,this.parentIndex),this.injectorGet(import11.TranslateService,this.parentIndex));
    this.compView_0.create(this._DefaultInstructionsComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._DefaultInstructionsComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.DefaultInstructionsComponent) && (0 === requestNodeIndex))) { return this._DefaultInstructionsComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DefaultInstructionsComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._DefaultInstructionsComponent_0_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const DefaultInstructionsComponentNgFactory:import8.ComponentFactory<import0.DefaultInstructionsComponent> = new import8.ComponentFactory<import0.DefaultInstructionsComponent>('default-instructions',View_DefaultInstructionsComponent_Host0,import0.DefaultInstructionsComponent);
const styles_DefaultInstructionsComponent:any[] = ([] as any[]);
class View_DefaultInstructionsComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgClass_2_3:import12.Wrapper_NgClass;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _NgClass_9_3:import12.Wrapper_NgClass;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _NgClass_17_3:import12.Wrapper_NgClass;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  _text_30:any;
  _map_34:any;
  /*private*/ _expr_35:any;
  _map_36:any;
  /*private*/ _expr_37:any;
  _pipe_translate_0:import13.TranslatePipe;
  /*private*/ _expr_39:any;
  /*private*/ _expr_40:any;
  /*private*/ _expr_41:any;
  /*private*/ _expr_42:any;
  _map_43:any;
  /*private*/ _expr_44:any;
  _pipe_translate_1:import13.TranslatePipe;
  /*private*/ _expr_46:any;
  /*private*/ _expr_47:any;
  /*private*/ _expr_48:any;
  _pipe_translate_2:import13.TranslatePipe;
  /*private*/ _expr_50:any;
  _pipe_translate_3:import13.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_DefaultInstructionsComponent1,renderType_DefaultInstructionsComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_34 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'card-small-green': p0};
    });
    this._expr_35 = import1.UNINITIALIZED;
    this._map_36 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'default-instruction-inactive-buttons': p0};
    });
    this._expr_37 = import1.UNINITIALIZED;
    this._expr_39 = import1.UNINITIALIZED;
    this._expr_40 = import1.UNINITIALIZED;
    this._expr_41 = import1.UNINITIALIZED;
    this._expr_42 = import1.UNINITIALIZED;
    this._map_43 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-disabled': p0};
    });
    this._expr_44 = import1.UNINITIALIZED;
    this._expr_46 = import1.UNINITIALIZED;
    this._expr_47 = import1.UNINITIALIZED;
    this._expr_48 = import1.UNINITIALIZED;
    this._expr_50 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-12 card-small-content'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','card-small default-instructions-card -eva-3-mb-lg'),(null as any));
    this._NgClass_2_3 = new import12.Wrapper_NgClass(this.parentView.parentView.injectorGet(import15.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import16.KeyValueDiffers,this.parentView.parentIndex),new import17.ElementRef(this._el_2),this.renderer);
    this._text_3 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','card-small-green-icon'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'i',new import3.InlineArray2(2,'class','eva-3-icon-checkmark-circle -eva-3-tc-green-3 -eva-3-icon-lg'),(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._text_8 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_2,'h5',new import3.InlineArray2(2,'class','eva-3-h5 -eva-3-pb-lg'),(null as any));
    this._NgClass_9_3 = new import12.Wrapper_NgClass(this.parentView.parentView.injectorGet(import15.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import16.KeyValueDiffers,this.parentView.parentIndex),new import17.ElementRef(this._el_9),this.renderer);
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_2,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n            ',(null as any));
    this._text_14 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_2,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                    ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_15,'dsp-button',new import3.InlineArray4(4,'size','md','variation','ghost'),(null as any));
    this._NgClass_17_3 = new import12.Wrapper_NgClass(this.parentView.parentView.injectorGet(import15.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import16.KeyValueDiffers,this.parentView.parentIndex),new import17.ElementRef(this._el_17),this.renderer);
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_15,'\n            ',(null as any));
    this._text_20 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_2,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n                ',(null as any));
    this._el_23 = import3.createRenderElement(this.renderer,this._el_21,'dsp-button',new import3.InlineArray4(4,'size','md','variation','ghost'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'',(null as any));
    this._text_25 = this.renderer.createText(this._el_21,'\n                ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_21,'dsp-button',new import3.InlineArray4(4,'size','md','variation','link'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'',(null as any));
    this._text_28 = this.renderer.createText(this._el_21,'\n            ',(null as any));
    this._text_29 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._text_30 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._pipe_translate_0 = new import13.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_17,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_17));
    this._pipe_translate_1 = new import13.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_23,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_23));
    this._pipe_translate_2 = new import13.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_26,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_26));
    this._pipe_translate_3 = new import13.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._text_28,
      this._text_29,
      this._text_30
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.NgClass) && ((9 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._NgClass_9_3.context; }
    if (((token === import18.NgClass) && ((17 <= requestNodeIndex) && (requestNodeIndex <= 18)))) { return this._NgClass_17_3.context; }
    if (((token === import18.NgClass) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 29)))) { return this._NgClass_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_2_0_0:any = 'card-small default-instructions-card -eva-3-mb-lg';
    this._NgClass_2_3.check_klass(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this._map_34(!this.parentView.context.isHidden(this.context.$implicit));
    this._NgClass_2_3.check_ngClass(currVal_2_0_1,throwOnChange,false);
    this._NgClass_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_9_0_0:any = 'eva-3-h5 -eva-3-pb-lg';
    this._NgClass_9_3.check_klass(currVal_9_0_0,throwOnChange,false);
    const currVal_9_0_1:any = this._map_36(this.parentView.context.isHidden(this.context.$implicit));
    this._NgClass_9_3.check_ngClass(currVal_9_0_1,throwOnChange,false);
    this._NgClass_9_3.ngDoCheck(this,this._el_9,throwOnChange);
    const currVal_17_0_0:any = this._map_43(this.parentView.context.isDisabled());
    this._NgClass_17_3.check_ngClass(currVal_17_0_0,throwOnChange,false);
    this._NgClass_17_3.ngDoCheck(this,this._el_17,throwOnChange);
    const currVal_35:any = this.parentView.context.isHidden(this.context.$implicit);
    if (import3.checkBinding(throwOnChange,this._expr_35,currVal_35)) {
      this.renderer.setElementProperty(this._el_4,'hidden',currVal_35);
      this._expr_35 = currVal_35;
    }
    valUnwrapper.reset();
    const currVal_37:any = import3.inlineInterpolate(1,'\n                ',valUnwrapper.unwrap(this._pipe_translate_0.transform(('pointOfSale.meetingType.' + this.context.$implicit))),'\n            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_37,currVal_37))) {
      this.renderer.setText(this._text_10,currVal_37);
      this._expr_37 = currVal_37;
    }
    const currVal_39:any = import3.inlineInterpolate(1,'default-instruction-description-',this.context.$implicit,'');
    if (import3.checkBinding(throwOnChange,this._expr_39,currVal_39)) {
      this.renderer.setElementProperty(this._el_12,'id',currVal_39);
      this._expr_39 = currVal_39;
    }
    const currVal_40:boolean = !this.parentView.context.isHidden(this.context.$implicit);
    if (import3.checkBinding(throwOnChange,this._expr_40,currVal_40)) {
      this.renderer.setElementProperty(this._el_15,'hidden',currVal_40);
      this._expr_40 = currVal_40;
    }
    const currVal_41:any = import3.inlineInterpolate(1,'',this.context.$implicit,'');
    if (import3.checkBinding(throwOnChange,this._expr_41,currVal_41)) {
      this.renderer.setElementProperty(this._el_17,'qadata',currVal_41);
      this._expr_41 = currVal_41;
    }
    const currVal_42:any = import3.inlineInterpolate(1,'',this.parentView.context.isDisabled(),'');
    if (import3.checkBinding(throwOnChange,this._expr_42,currVal_42)) {
      this.renderer.setElementProperty(this._el_17,'disabled',currVal_42);
      this._expr_42 = currVal_42;
    }
    valUnwrapper.reset();
    const currVal_44:any = import3.inlineInterpolate(1,'\n                        ',valUnwrapper.unwrap(this._pipe_translate_1.transform('common.SELECT')),'\n                    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_44,currVal_44))) {
      this.renderer.setText(this._text_18,currVal_44);
      this._expr_44 = currVal_44;
    }
    const currVal_46:any = this.parentView.context.isHidden(this.context.$implicit);
    if (import3.checkBinding(throwOnChange,this._expr_46,currVal_46)) {
      this.renderer.setElementProperty(this._el_21,'hidden',currVal_46);
      this._expr_46 = currVal_46;
    }
    const currVal_47:any = import3.inlineInterpolate(1,'',this.context.$implicit,'');
    if (import3.checkBinding(throwOnChange,this._expr_47,currVal_47)) {
      this.renderer.setElementProperty(this._el_23,'qadata',currVal_47);
      this._expr_47 = currVal_47;
    }
    valUnwrapper.reset();
    const currVal_48:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('common.EDIT')),'\n                ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_48,currVal_48))) {
      this.renderer.setText(this._text_24,currVal_48);
      this._expr_48 = currVal_48;
    }
    valUnwrapper.reset();
    const currVal_50:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('common.CANCEL')),'\n                ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_50,currVal_50))) {
      this.renderer.setText(this._text_27,currVal_50);
      this._expr_50 = currVal_50;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_17(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.selectClic(this.context.$implicit)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_23(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.editClic(this.context.$implicit)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_26(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.clear(this.context.$implicit)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_DefaultInstructionsComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_DefaultInstructionsComponent,{});
export class View_DefaultInstructionsComponent0 extends import2.AppView<import0.DefaultInstructionsComponent> {
  _viewQuery_defaultInstructionsDescription_0:import19.QueryList<any>;
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import14.ViewContainer;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import20.Wrapper_NgFor;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_DefaultInstructionsComponent0,renderType_DefaultInstructionsComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._viewQuery_defaultInstructionsDescription_0 = new import19.QueryList<any>();
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-3-row cards-small-container'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import14.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import21.TemplateRef_(this,2,this._anchor_2);
    this._NgFor_2_6 = new import20.Wrapper_NgFor(this._vc_2.vcRef,this._TemplateRef_2_5,this.parentView.injectorGet(import15.IterableDiffers,this.parentIndex),this.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n\n',(null as any));
    this._text_4 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._viewQuery_defaultInstructionsDescription_0.reset(([] as any[]));
    this.context.description = this._viewQuery_defaultInstructionsDescription_0.first;
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._text_4
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import21.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import22.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.context.meetingType;
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,false);
    this._NgFor_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 2)) { return new View_DefaultInstructionsComponent1(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/pointOfSale/delivery-instructions/default-instructions/default-instructions.component.ngfactory.ts